import { AutoComplete, Badge, Button, Dropdown, Input, Space } from 'antd';
import { BellOutlined, GlobalOutlined, UserOutlined, SearchOutlined } from '@ant-design/icons';

const searchOptions = [
  { value: 'superstores', label: 'Superstores' },
  { value: 'hubs', label: 'Child Hubs' },
  { value: 'products', label: 'Products' },
  { value: 'suppliers', label: 'Suppliers' },
  { value: 'users', label: 'Users' },
];

const userMenu = {
  items: [
    { key: 'profile', label: 'Profile' },
    { key: 'settings', label: 'Settings' },
    { type: 'divider' as const },
    { key: 'signout', label: 'Sign out', danger: true },
  ],
};

export function AppTopBar() {
  return (
    <div
      style={{
        height: 56,
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        gap: 16,
      }}
    >
      <div
        style={{
          fontSize: 18,
          fontWeight: 700,
          color: '#1f4e3d',
          letterSpacing: 0.3,
        }}
      >
        🌿 RUNNUR
      </div>
      <div style={{ flex: 1, maxWidth: 480, margin: '0 auto' }}>
        <AutoComplete
          options={searchOptions}
          style={{ width: '100%' }}
          popupMatchSelectWidth={480}
        >
          <Input
            size="middle"
            prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
            placeholder="Search superstores, hubs, products, SKUs, suppliers, users… (press /)"
            allowClear
          />
        </AutoComplete>
      </div>
      <Space size="middle">
        <Button type="text" icon={<GlobalOutlined />}>
          Gannavaram · All
        </Button>
        <Badge count={3} size="small">
          <Button type="text" icon={<BellOutlined />} />
        </Badge>
        <Dropdown menu={userMenu} trigger={['click']}>
          <Button type="text" icon={<UserOutlined />}>
            K. Rao
          </Button>
        </Dropdown>
      </Space>
    </div>
  );
}